<template>
  <div class="high_salary" v-loading="loading">
    <div class="conent">
      <el-row>
        <el-col :span="2">
          <el-select v-model="value" placeholder="请选择查询状态">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2" style="margin: 0 5px">
          <el-cascader
            placeholder="请选择职业地点"
            class="input"
            v-model="place_value"
            :options="place_data"
            v-if="$cookies.get('auth_grade') == 100"
          ></el-cascader>
        </el-col>
        <el-col :span="2">
          <el-input
            v-model="sensitive_word"
            placeholder="请输入内容"
          ></el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="search" style="margin-left: 12px"
            >查询</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        style="width: 100%"
        @row-click="rowClick"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="company_name" label="公司名"></el-table-column>
        <el-table-column prop="username" label="用户账号"></el-table-column>
        <el-table-column
          prop="agent_company_name"
          label="所属代理商"
        ></el-table-column>
        <el-table-column prop="jd_position_name" label="招聘职位">
        </el-table-column>
        <el-table-column
          prop="jd_place_name"
          label="职位地点"
        ></el-table-column>
        <el-table-column prop label="职位薪资">
          <template slot-scope="scope"
            >{{ scope.row.jd_salary_min }}-{{
              scope.row.jd_salary_max
            }}
            元</template
          >
        </el-table-column>
        <el-table-column prop="jd_place_name" label="招聘规模">
          <template slot-scope="scope"
            >{{ scope.row.jd_people_max }} 人</template
          >
        </el-table-column>
        <el-table-column
          prop="jd_place_name"
          label="职位地点"
        ></el-table-column>
        <el-table-column prop="update_time" label="更新时间"></el-table-column>
        <el-table-column prop="create_time" label="创建时间"></el-table-column>
        <el-table-column prop="jd_hide" label="审核状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.jd_status == 0"
              >已上架</el-tag
            >
            <el-tag type="danger" v-if="scope.row.jd_status == 1"
              >正在审核</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="200">
          <template slot-scope="scope">
            <div>
              <el-button
                v-if="scope.row.jd_status == 1"
                size="mini"
                type="warning"
                @click.stop="handleAdd(scope.row)"
                >上架</el-button
              >
              <el-button
                size="mini"
                type="danger"
                @click.stop="handleDelete(scope.row)"
                >下架</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="15"
          :total="total"
          :current-page="pageCurrent"
          hide-on-single-page
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
// import { ElSelect } from "element-ui/types/select";
export default {
  name: "",
  //组件引入
  components: {},
  //状态存储
  data() {
    return {
      tableData: [],
      sensitive_vocabulary: [
        "国家级",
        "最高级",
        "最佳",
        "催情粉",
        "催情巧克力",
        "春药",
        "枪支",
        "弹药",
        "军火",
        "警用",
        "军用",
        "电击器",
        "强光手电筒",
        "毒品",
        "制毒",
        "剧毒",
        "麻醉",
        "有毒",
        "放射",
        "赌博",
        "高薪低门槛",
        "生活助理",
        "私人秘书",
        "招聘陪同",
        "伴游司机",
        "驾照销分",
        "代办违章",
        "挂证",
        "挂靠",
        "挂章",
        "资质升级",
        "初始转注册",
        "代考试信息",
        "爆破证挂靠",
        "代开发票",
        "非法代办",
        "侦探",
        "保镖",
        "暴力清债",
        "代体检",
        "测试胎儿性别",
        "捐赠人体器官",
        "遗体",
        "血液",
        "捐赠血小板",
        "代孕",
        "捐精",
        "捐卵",
        "管制类刀具",
        "男朋友",
        "女朋友",
        "影视演员",
        "群众演员",
        "直播歌手",
        "武术替身",
        "操盘手",
        "期货居间人",
        "主播",
        "国家电网",
        "电力公司",
        "水利局",
        "出国劳务",
      ],
      total: 0,
      pageCurrent: 1,
      page: 0,
      options: [
        {
          value: 0,
          label: "已上架",
        },
        {
          value: 1,
          label: "正在审核",
        },
      ],
      value: "",
      oldValue: "",
      place_value: [],
      place_data: [],
      old_place_value: [],
      isSearch: false,
      router_jd_status: "",
      sensitive_word: "",
      old_sensitive_word: "",
      loading: false,
    };
  },
  //计算属性
  computed: {},
  //状态监听
  watch: {
    // 用不了，因为router里面这个vue没有在children里面写
    // $route(to, from) {
    //   console.log(to, "111111111111111111111111111111111111111111111");
    //   console.log(1111111111111111111111111111111111111111);
    //   if (to.fullPath) {
    //     console.log(1111111111111111111111111111);
    //     this.value =
    //       isNaN(Number(this.$route.query.jd_status)) === true
    //         ? ""
    //         : Number(this.$route.query.jd_status);
    //     this.router_jd_status =
    //       this.$route.query.jd_status === undefined
    //         ? ""
    //         : this.$route.query.jd_status;
    //     this.position_list();
    //   }
    // },
  },
  //存放方法集合
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.sensitive_position == true) {
        return "warning-row";
      }
      return "";
    },
    // 查询
    search() {
      this.page = 0;
      this.pageCurrent = 1;
      // 查询条件有值，点击分页请求接口会携带值
      this.isSearch = true;
      // 旧数据记录，与没有点击查询之后的新数据作比较，
      this.oldValue = this.value;
      this.old_place_value = this.place_value;
      this.old_sensitive_word = this.sensitive_word;
      this.position_list();
    },
    // 获取地址
    positionLocation() {
      var arr = [];
      require("post", "/commonality/v1/show_place_json/", {}).then((res) => {
        if (!res.code) {
          let data1 = res.data;
          data1.forEach((item, index1) => {
            arr.push({
              label: item.label,
              value: item.value,
              children: [],
            });
            item.children.forEach((item) => {
              arr[index1].children.push({
                label: item.label,
                value: item.value,
              });
            });
          });
          this.place_data = arr;
        }
      });
    },
    // 改变分页页码
    pageChange(page) {
      this.page = page - 1;
      this.pageCurrent = page;
      this.position_list();
    },
    // 获取职位列表
    position_list() {
      this.loading = true;
      // 判断是否点击了查询，        解决改变条件以后没点查询，就点击分页，出现显示错误的情况
      if (this.isSearch === true) {
        var newValue;
        var new_sensitive_word;
        if (this.oldValue === this.value) {
          newValue = this.value;
        } else {
          newValue = this.oldValue;
        }
        if (this.old_sensitive_word == this.sensitive_word) {
          new_sensitive_word = this.sensitive_word;
        } else {
          new_sensitive_word = this.old_sensitive_word;
        }
        var newLocation = [];
        if (this.place_value.length > 0) {
          // for (var i = 0; i < this.place_value.length; i++) {
          //   if (this.old_place_value[i] === this.place_value[i]) {
          //     newLocation.push(this.place_value[i]);
          //   } else {
          //     newLocation.push(this.old_place_value[i]);
          //   }
          // }
          this.place_value.forEach((item, index) => {
            if (item === this.old_place_value[index]) {
              newLocation.push(item);
            } else {
              newLocation.push(this.old_place_value[index]);
            }
          });
        }
        console.log(newLocation);
        if (newLocation.length > 0) {
          newLocation = newLocation.slice(1, 2).toString();
        } else {
          newLocation = "";
        }
        require("post", "/hr24_index_data/v1/all_jd/", {
          page: this.page,
          jd_status: newValue,
          city_id: newLocation,
          sensitive_word: new_sensitive_word,
        }).then((res) => {
          if (!res.code) {
            this.loading = false;
            console.log(res);
            this.tableData = res.data.jd_data;
            this.total = res.data.jd_count;
            this.tableData.forEach((item, index) => {
              this.sensitive_vocabulary.forEach((item1) => {
                if (item.jd_position_name.indexOf(item1) > -1) {
                  console.log(item);
                  this.tableData[index].sensitive_position = true;
                }
              });
            });
          }
        });
      } else {
        require("post", "/hr24_index_data/v1/all_jd/", {
          page: this.page,
          jd_status: this.router_jd_status,
        }).then((res) => {
          if (!res.code) {
            this.loading = false;
            console.log(res);
            this.tableData = res.data.jd_data;
            this.total = res.data.jd_count;
            // sensitive_description = "";
            this.tableData.forEach((item, index) => {
              this.sensitive_vocabulary.forEach((item1) => {
                if (item.jd_position_name.indexOf(item1) > -1) {
                  console.log(item);
                  this.tableData[index].sensitive_position = true;
                }
              });
            });
          }
        });
      }
    },
    // 上架
    handleAdd(row) {
      this.$confirm("是否上架该职位", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        require("post", "/hr24_index_data/v1/out_report_jd/", {
          jd_id: row.id,
          jd_hide: 0,
          jd_status: 0,
        }).then((res) => {
          if (!res.code) {
            this.$message({
              type: "info",
              message: "上架成功",
            });
            this.position_list();
          }
        });
      });
    },
    // 下架
    handleDelete(row) {
      let objects;
      if (row.jd_status === 0) {
        objects = { jd_id: row.id, jd_hide: 1 };
      } else {
        objects = { jd_id: row.id, jd_hide: 1, jd_status: 2 };
      }
      this.$confirm("是否下架该职位", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        require("post", "/hr24_index_data/v1/out_report_jd/", objects).then(
          (res) => {
            if (!res.code) {
              this.$message({
                type: "info",
                message: "下架成功",
              });
              this.position_list();
            }
          }
        );
      });
    },
    // 点击某一行触发,进去详情
    rowClick(row, column, event) {
      this.$router.push({
        path: "/job_details",
        query: { id: row.id },
      });
      sessionStorage.setItem("id", 1);
    },
  },
  //数据初始化之后
  created() {},
  //页面渲染之后
  mounted() {},
  //数据初始化之前
  beforeCreate() {},
  //页面渲染之前
  beforeMount() {},
  //状态更新之前
  beforeUpdate() {},
  //状态更新之后
  updated() {},
  //页面卸载之前
  beforeDestroy() {},
  //卸载之后
  destroyed() {},
  //页面进入   页面缓存时有效
  activated() {
    // 获取地址
    this.positionLocation();
    // 判断有没有储存的值
    /**
     * 如果有这个值，那就是从详情页过来的，就要用离开之前储存的data数据进行请求
     * 如果没有这个值，那就是从别的路由过来的，就需要把请求的值，变成初始值然后去请求接口
     */
    if (sessionStorage.getItem("id")) {
      if (this.$route.query.page && this.$route.query.jd_status) {
        this.isSearch = false;
        this.page = Number(this.$route.query.page);
        this.router_jd_status = Number(this.$route.query.jd_status);
        this.value = Number(this.$route.query.jd_status);
      }
      this.position_list();
      sessionStorage.removeItem("id");
    } else {
      this.page = 0;
      this.pageCurrent = 1;
      this.isSearch = false;
      if (this.$route.query.page && this.$route.query.jd_status) {
        this.page = Number(this.$route.query.page);
        this.router_jd_status = Number(this.$route.query.jd_status);
        this.value = Number(this.$route.query.jd_status);
      }
      this.value = "";
      this.place_value = [];
      this.sensitive_word = "";

      this.oldValue = "";
      this.old_place_value = [];
      this.old_sensitive_word = "";

      this.position_list();
    }
  },
};
</script>
<style  scoped>
.el-table >>> .warning-row {
  background: rgb(240, 196, 196);
}
.high_salary {
  width: calc(100% - 190px);
  min-height: 80vh;
  background: #fff;
  margin-top: 68px;
  margin-left: 190px;
}
.conent {
  width: 90%;
  margin: auto;
  padding: 60px 0;
}
.page {
  padding: 20px 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/user_management/position_review.vue